<main class="p-6 bg-lGray950 rounded-3xl">
  <div class="mb-5 flex flex-col gap-4 xl:flex-row xl:items-center xl:justify-between">
    <div>
      <h1 class="text-[2.05rem] font-bold leading-8 text-color">{{ pageTitle }}</h1>

      <p class="mt-1 text-sm" 
        [ngClass]="{
          'text-lDanger': listingMode === courseListingMode.TRASH,
          'subtext-color': listingMode !== courseListingMode.TRASH
        }"
      >
        {{ pageDescription }}
      </p>
    </div>

    <div class="flex w-full flex-col gap-3 sm:flex-row sm:items-center sm:justify-end xl:w-auto">
      <div class="relative w-full sm:w-[344px]">
        <l-icon class="pointer-events-none absolute left-5 top-1/2 -translate-y-1/2 text-[1.35rem] text-lGray600" icon="search" />
        <input
          lInput
          class="w-full !h-10 !rounded-full !bg-lGray900 !border-lGray700 !text-lSecondary placeholder:!text-lSecondary !pl-14 !pr-5 !text-base"
          placeholder="Pesquisar curso"
          [formControl]="searchControl"
        />
      </div>

      @if (showAdvancedFilters) {
        <l-course-filter
          [categories]="categories"
          [selectedStatus]="selectedStatusFilter"
          [selectedCategories]="selectedCategoryFilters"
          [selectedDateRange]="selectedDateRangeFilter"
          (filterApplied)="onFilterApplied($event)"
        />
      }

      <button
        lButton
        [bType]="buttonTypeEnum.PRIMARY"
        [bSize]="buttonSizeEnum.MEDIUM"
        [bRadius]="buttonRadiusEnum.CIRCLE"
        class="!h-10 !min-w-[176px] !px-8 !text-base"
        (click)="navigateToCreateCourse()"
      >
        Criar curso
      </button>
    </div>
  </div>

  @if (appliedFilterPills.length > 0) {
    <div class="mb-5 flex flex-wrap items-center gap-2">
      @for (pill of appliedFilterPills; track pill.key) {
        <button
          type="button"
          class="inline-flex items-center gap-2 rounded-full border border-lGray700 bg-lGray900 px-3 py-1.5 text-xs font-medium text-lWhite transition-all duration-200 hover:bg-lGray800"
          (click)="removeFilterPill(pill)"
        >
          <span>{{ pill.label }}</span>
          <l-icon class="text-sm">close</l-icon>
        </button>
      }
    </div>
  }

  @if (loadErrorMessage && !isLoading) {
    <div class="flex min-h-[240px] items-center justify-center rounded-2xl bg-lGray900 px-6 py-10 text-center">
      <p class="text-lDanger">{{ loadErrorMessage }}</p>
    </div>
  } @else {
    <l-course-table
      [limit]="limit"
      [page]="page"
      [data]="courses"
      [sort]="sort"
      [total]="source.total"
      [isLoading]="isLoading"
      [categories]="categories"
      [getRowActions]="getRowActions.bind(this)"
      (pageChange)="onChangePage($event)"
      (sortChange)="onChangeSort($event)"
    />
  }
</main>
